export const URL_BIBLE = process.env.NEXT_PUBLIC_BIBLE_CLOUDFRONT_URL ?? "";

export const URL_BIBLE_IMAGE =
  "https://images.hallow.app/assets/purple_bible_image.webp";
export const BIBLE_HEX = "#6757C4";
